export const configStaffAreasOutreach = [
	
	// {
	// 	"id": "bc280922-3b4c-454d-8d3c-3cd8c75abdba",
	// 	"displayName": "tl7_dannevirke",
	// 	"groupType": "Security",
	// 	"membershipType": "Assigned",
	// 	"source": "Cloud",
	// 	"mail": "",
	// 	"securityEnabled": "TRUE",
	// 	"mailEnabled": "FALSE",
	// 	"isAssignableToRole": "FALSE",
	// 	"onPremisesSyncEnabled": ""
	// },
	{
		"id": "c5f3ad2b-0d1f-4d60-8660-bb25fbbceef1",
		"displayName": "outreach_aklc_am",
		"groupType": "Security",
		"membershipType": "Assigned",
		"source": "Cloud",
		"mail": "",
		"securityEnabled": "TRUE",
		"mailEnabled": "FALSE",
		"isAssignableToRole": "FALSE",
		"onPremisesSyncEnabled": ""
	},
	{
		"id": "95ace09f-f24d-4ae0-befd-dd1390f247f4",
		"displayName": "outreach_ko_kaitaia",
		"groupType": "Security",
		"membershipType": "Assigned",
		"source": "Cloud",
		"mail": "",
		"securityEnabled": "TRUE",
		"mailEnabled": "FALSE",
		"isAssignableToRole": "FALSE",
		"onPremisesSyncEnabled": ""
	},
	{
		"id": "6c2428f5-673d-4851-9431-3224e714db32",
		"displayName": "outreach_ko_whangarei",
		"groupType": "Security",
		"membershipType": "Assigned",
		"source": "Cloud",
		"mail": "",
		"securityEnabled": "TRUE",
		"mailEnabled": "FALSE",
		"isAssignableToRole": "FALSE",
		"onPremisesSyncEnabled": ""
	},
	{
		"id": "574ce68b-e0d0-4f26-a70d-83d577e3e688",
		"displayName": "outreach_vet_galatea",
		"groupType": "Security",
		"membershipType": "Assigned",
		"source": "Cloud",
		"mail": "",
		"securityEnabled": "TRUE",
		"mailEnabled": "FALSE",
		"isAssignableToRole": "FALSE",
		"onPremisesSyncEnabled": ""
	},
	{
		"id": "50c95521-0495-4a66-9f8a-efce0405da65",
		"displayName": "outreach_vet_opotiki",
		"groupType": "Security",
		"membershipType": "Assigned",
		"source": "Cloud",
		"mail": "",
		"securityEnabled": "TRUE",
		"mailEnabled": "FALSE",
		"isAssignableToRole": "FALSE",
		"onPremisesSyncEnabled": ""
	},
	{
		"id": "88074862-d2ec-4038-95e5-8e786e0fe25e",
		"displayName": "outreach_drp_akl",
		"groupType": "Security",
		"membershipType": "Assigned",
		"source": "Cloud",
		"mail": "",
		"securityEnabled": "TRUE",
		"mailEnabled": "FALSE",
		"isAssignableToRole": "FALSE",
		"onPremisesSyncEnabled": ""
	},
	{
		"id": "55787392-91e7-4e12-a99a-67e6a51e91c2",
		"displayName": "outreach_cccr",
		"groupType": "Security",
		"membershipType": "Assigned",
		"source": "Cloud",
		"mail": "",
		"securityEnabled": "TRUE",
		"mailEnabled": "FALSE",
		"isAssignableToRole": "FALSE",
		"onPremisesSyncEnabled": ""
	},
	{
		"id": "329287ff-1d1f-4628-ad2e-d337eb28f0ad",
		"displayName": "outreach_wcr",
		"groupType": "Security",
		"membershipType": "Assigned",
		"source": "Cloud",
		"mail": "",
		"securityEnabled": "TRUE",
		"mailEnabled": "FALSE",
		"isAssignableToRole": "FALSE",
		"onPremisesSyncEnabled": ""
	},
	{
		"id": "851e2938-b177-4b71-b1de-c0f4058694e5",
		"displayName": "outreach_bdt",
		"groupType": "Security",
		"membershipType": "Assigned",
		"source": "Cloud",
		"mail": "",
		"securityEnabled": "TRUE",
		"mailEnabled": "FALSE",
		"isAssignableToRole": "FALSE",
		"onPremisesSyncEnabled": ""
	},
	{
		"id": "f2a7ae48-1a35-40f3-8ef2-de280294ea63",
		"displayName": "outreach_vet_farnorth",
		"groupType": "Security",
		"membershipType": "Assigned",
		"source": "Cloud",
		"mail": "",
		"securityEnabled": "TRUE",
		"mailEnabled": "FALSE",
		"isAssignableToRole": "FALSE",
		"onPremisesSyncEnabled": ""
	},
	{
		"id": "639662bd-64b9-4d51-9aa9-50f3b2812650",
		"displayName": "outreach_vet_topvets",
		"groupType": "Security",
		"membershipType": "Assigned",
		"source": "Cloud",
		"mail": "",
		"securityEnabled": "TRUE",
		"mailEnabled": "FALSE",
		"isAssignableToRole": "FALSE",
		"onPremisesSyncEnabled": ""
	},
	{
		"id": "846277eb-91ef-4125-8489-6422bb583004",
		"displayName": "outreach_vet_vettrust",
		"groupType": "Security",
		"membershipType": "Assigned",
		"source": "Cloud",
		"mail": "",
		"securityEnabled": "TRUE",
		"mailEnabled": "FALSE",
		"isAssignableToRole": "FALSE",
		"onPremisesSyncEnabled": ""
	},
	{
		"id": "63c83493-9a0b-4aa7-9a82-c98a4fcfcf10",
		"displayName": "outreach_vet_pianohill",
		"groupType": "Security",
		"membershipType": "Assigned",
		"source": "Cloud",
		"mail": "",
		"securityEnabled": "TRUE",
		"mailEnabled": "FALSE",
		"isAssignableToRole": "FALSE",
		"onPremisesSyncEnabled": ""
	},
	{
		"id": "d983a5ec-60e2-4cc8-94be-7c3dcad7c0c8",
		"displayName": "outreach_vet_mogdog",
		"groupType": "Security",
		"membershipType": "Assigned",
		"source": "Cloud",
		"mail": "",
		"securityEnabled": "TRUE",
		"mailEnabled": "FALSE",
		"isAssignableToRole": "FALSE",
		"onPremisesSyncEnabled": ""
	},
	{
		"id": "7d2d2881-7855-4e6a-9ec2-d410b70d92dd",
		"displayName": "outreach_vet_mangere",
		"groupType": "Security",
		"membershipType": "Assigned",
		"source": "Cloud",
		"mail": "",
		"securityEnabled": "TRUE",
		"mailEnabled": "FALSE",
		"isAssignableToRole": "FALSE",
		"onPremisesSyncEnabled": ""
	},
	{
		"id": "2ff4ba43-1437-4c48-aab2-f66134ae667d",
		"displayName": "outreach_vetlife_ashburton",
		"groupType": "Security",
		"membershipType": "Assigned",
		"source": "Cloud",
		"mail": "",
		"securityEnabled": "TRUE",
		"mailEnabled": "FALSE",
		"isAssignableToRole": "FALSE",
		"onPremisesSyncEnabled": ""
	},
	{
		"id": "008dda36-0e29-4a1d-a3ce-9334c4839094",
		"displayName": "outreach_aklc_paremoremo",
		"groupType": "Security",
		"membershipType": "Assigned",
		"source": "Cloud",
		"mail": "",
		"securityEnabled": "TRUE",
		"mailEnabled": "FALSE",
		"isAssignableToRole": "FALSE",
		"onPremisesSyncEnabled": ""
	},
	{
		"id": "e32ede8f-7872-4bba-9b31-c9caf7dc2376",
		"displayName": "outreach_fndc_kaitaia",
		"groupType": "Security",
		"membershipType": "Assigned",
		"source": "Cloud",
		"mail": "",
		"securityEnabled": "TRUE",
		"mailEnabled": "FALSE",
		"isAssignableToRole": "FALSE",
		"onPremisesSyncEnabled": ""
	},
	{
		"id": "cae9211e-316c-4d7c-a4e1-62108f637cbd",
		"displayName": "outreach_aklc_rdlb",
		"groupType": "Security",
		"membershipType": "Assigned",
		"source": "Cloud",
		"mail": "",
		"securityEnabled": "TRUE",
		"mailEnabled": "FALSE",
		"isAssignableToRole": "FALSE",
		"onPremisesSyncEnabled": ""
	}
];